module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.10095/images/blonde-shelley/blonde-shelley@1x.png"